var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox"},[_vm._t("default"),_c('input',{attrs:{"type":"checkbox"},domProps:{"value":_vm.mutable_checked,"checked":_vm.mutable_checked},on:{"click":function($event){return _vm.toggle()}}}),_c('span',{staticClass:"checkmark",class:_vm.checkStyle})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }